import LazyLoad from "react-lazy-load";

const LoadableImage = ({src, alt}) => {
  return (
    <div style={{width: "100%", minHeight: "240px", maxHeight: "2400px"}}>
      <LazyLoad>
        <img src={src} alt={alt} />
      </LazyLoad>
    </div>
  );
}

export default LoadableImage;
